import React from "react";
import { Button, Modal } from "react-bootstrap";

export default function ProductsLearnMoreModal({
  selectedProduct,
  handleCloseModal,
}) {
  return (
    <div>
      <Modal show={Boolean(selectedProduct)} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedProduct?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>For more information please contact our support team.</div>
          <div className="my-2">Call us at +44(0)207 224 5555</div>
          <div className="d-flex gap-1 my-2">
            <div>Email us at</div>
            <div>
              <div>
                {" "}
                <a href="mailto:support@boomcomms.com">support@boomcomms.com</a>
              </div>
              <div>
                {" "}
                <a href="mailto:sales@boomcomms.com">sales@boomcomms.com</a>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2 p-3">
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
